import { render, staticRenderFns } from "./TimelineChart.vue?vue&type=template&id=54de62a9&"
import script from "./TimelineChart.vue?vue&type=script&lang=js&"
export * from "./TimelineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports